export default __webpack_public_path__ + "static/kelowna-951989c44517aea0079036b50513144a.jpg";